import { Box, Skeleton, useToast } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetUserActiveCreditFacilitiesQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import {
  dashboardRoutePadding,
  errorToastConfig,
} from 'packages/common-frontend/constants';
import { VerificationHistoryTable } from 'packages/verifications/ui/VerificationHistoryTable';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const VerificationHistoryRoute = () => {
  const toast = useToast();
  const flags = useFeatureFlags();
  const { data: userData } = useGetUserActiveCreditFacilitiesQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
    variables: {
      creditFacilitySlugsToHide: flags?.creditFacilitySlugsToHide ?? [],
    },
  });

  if (!userData || !userData.user) {
    return (
      <Skeleton data-testid="loading-verification-history" height="600px" />
    );
  }

  return (
    <Box padding={dashboardRoutePadding}>
      <VerificationHistoryTable organizationId={userData.user.organizationId} />
    </Box>
  );
};
